import { useLocation } from '@/services/router/compat';

const AGENT_ROUTE_PATTERN = /\/workspaces\/\d+\/agent(\/|$)/;
/**
 * Returns true when the user is on any `/agent` fullscreen page
 * (chat, routine, etc.). This is purely URL-based — no route IDs.
 *
 * Used to prevent the copilot sidebar from rendering (avoids
 * double-rendering the chat UI) and to hide UI elements that
 * overlap with the fullscreen agent layout.
 */
export function useIsAgentFullscreen() {
  const { pathname } = useLocation();
  return AGENT_ROUTE_PATTERN.test(pathname);
}

/**
 * Returns true when the assistant footer bar should be visible.
 * Hidden when the agent is fullscreen (which has its own chrome).
 */
export function useShouldShowAgentBar() {
  const { pathname } = useLocation();
  return !AGENT_ROUTE_PATTERN.test(pathname);
}
